import Marionette from "../../../shared/marionette-mustache";
import { CaseRelationModel } from "../../../desktop/models/case-relation";
import { backboneViewProperties } from "../../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "div",
})
export class CitedCaseRelationView extends Marionette.ItemView<CaseRelationModel> {
    constructor(options?: Backbone.ViewOptions<CaseRelationModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/cited-case-relation.ts